import { Alert, message } from 'antd';
import CardFilters from './filters';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import apiCalls from 'src/api/apiCalls';
import CardTransactionsGrid from './grid'
import HeaderComponent from 'src/components/header';
import dayjs from 'dayjs';
const CardTransactions = () => {
  const [filterValues, setFilterValues] = useState({ "search": null, "Status": "All", "startDate": null, "endDate": null });
  const [error, setError] = useState(null);
  const [stateLu, setStateLu] = useState([]);
  const shouldLog = useRef(true);
  const [isExcelExport, setIsExcelExport] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState({})
  const refreshRef = useRef();
  const breadCrumbList = [
    { bname: 'Transactions' },
  ]
  useEffect(() => {
    if (shouldLog.current) {
      shouldLog.current = false;
      getStatusLu();
    }
  }, [])

  const getStatusLu = async () => {
    try {
      const response = await apiCalls.getCardsLookups('TransactionStateLu');
      if (response) {
        setStateLu(response.data?.TransactionState)
        setError(null)
      }
      else {
        setError(apiCalls.isErrorDispaly(response))
      }
    }
    catch (error) {
      setError(apiCalls.isErrorDispaly(error))
    }
  }
  const handleSearch = useCallback((values) => {
    let formattedDates = null;
    if (values?.dateRange) {
      formattedDates = values?.dateRange ? values?.dateRange?.map(date => dayjs(date).format('YYYY-MM-DD')) : null
    }
    setFilterValues({
      search: values?.search || null,
      Status: values?.Status || "All",
      startDate: formattedDates ? formattedDates[0] : null,
      toDate: formattedDates ? formattedDates[1] : null,
    });
  }, [])
  const handleExcelExport = useCallback(() => {
    setIsExcelExport(true);
    setTimeout(() => {
      setIsExcelExport(false)
    });
    message.destroy();
    message.success({
      content: 'Download Excel Successfully',
      className: 'custom-msg',
      duration: 3
    });
  }, [])
  const handleError = useCallback((error) => {
    setError(error)
  }, [])
  const closeError = useCallback(() => {
    setError(null)
  }, [])
  return (
    <div className=''>
      <HeaderComponent breadCrumbList={breadCrumbList} />
      {error &&
        <div className='mb-4'>
          <Alert
            className='mb-6'
            type="error"
            description={error}
            onClose={closeError}
            showIcon
            closable
          />
        </div>
      }
      <CardFilters handleExcelExport={handleExcelExport} filterObj={handleSearch} filterValues={filterValues} stateLu={stateLu} onloadGrid={refreshRef?.current?.loadGrid} selectedTransaction={selectedTransaction} handleError={handleError} />
      <CardTransactionsGrid filterValues={filterValues} ref={refreshRef} isExcelExport={isExcelExport} handleError={handleError} setSelectedTransaction={setSelectedTransaction} />
    </div>
  )
}
export default React.memo(CardTransactions);